import { render, staticRenderFns } from "./authManage.vue?vue&type=template&id=e5336072&scoped=true&"
import script from "./authManage.vue?vue&type=script&lang=js&"
export * from "./authManage.vue?vue&type=script&lang=js&"
import style0 from "./authManage.vue?vue&type=style&index=0&id=e5336072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5336072",
  null
  
)

export default component.exports